(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/middlewares/last-searched.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/middlewares/last-searched.js');
"use strict";


const _RTK = RTK,
  createListenerMiddleware = _RTK.createListenerMiddleware;
const _svs$components$casin = svs.components.casino_react.casinoStore.actions.lastSearched,
  addGameToLastSearched = _svs$components$casin.addGameToLastSearched,
  clearLastSearched = _svs$components$casin.clearLastSearched;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const putLastSearchedClient = svs.components.casino.lastSearched.putLastSearchedClient;
const lastSearchedListenerMiddleware = createListenerMiddleware();
lastSearchedListenerMiddleware.startListening({
  actionCreator: addGameToLastSearched,
  effect: async (_, listenerApi) => {
    if (!isLoggedIn) {
      return;
    }
    const lastSearched = listenerApi.getState().lastSearched;
    await putLastSearchedClient(lastSearched);
  }
});
lastSearchedListenerMiddleware.startListening({
  actionCreator: clearLastSearched,
  effect: async () => {
    if (!isLoggedIn) {
      return;
    }
    await putLastSearchedClient([]);
  }
});
setGlobal('svs.components.casino_react.casinoStore.middlewares.lastSearchedListenerMiddleware', lastSearchedListenerMiddleware);

 })(window);